import { memo as Memo, useMemo } from 'react'
import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'

const Page = Memo(({ meta, className, children }) => {

    //! Router
    const router = useRouter()

    //! Url
    const url = useMemo(() => process.env.NEXT_PUBLIC_APP_URL + router.asPath, [router])

    //! Title
    const title = useMemo(() => meta?.title || 'Oplos', [meta?.title])

    //! Description
    const description = useMemo(() => meta?.description || 'Oplos is an online debate platform where participants engage in discussions and debates across a variety of topics. Get ready for the next important debate!', [meta?.description])

    //! Keywords
    const keywords = useMemo(() => meta?.keywords || 'Oplos, Online debate, Debating platform, Online discussion club, Debate topics', [meta?.keywords])


    return (
        <>
            <NextSeo
                title={title}
                description={description}
                canonical={url}
                type='website'
                additionalMetaTags={[
                    {
                        name: 'keywords',
                        content: keywords,
                    },
                ]}
                openGraph={{
                    url: url,
                    title: title,
                    description: description,
                    images: [{ url: `${process.env.NEXT_PUBLIC_APP_URL}/meta.png`, alt: title }],
                }}
                twitter={{
                    handle: '@handle',
                    site: '@site',
                    cardType: 'summary_large_image',
                }}
            />
            <main className={`page ${className ? className : ''}`}>
                {children}
            </main>
        </>
    )
})

export default Page